import { type FunctionComponent, } from "react"
import { SelectableAssetDeposit } from "@components";
import { TOKENS } from "@const";
import { raise, bi, n, sn, } from "@helpers";
import { useEscrowStore } from "@stores/escrow";
import { getChainedToken, type TokenDefinition, } from "@bracket/addressbook";
import type { NumericString, TokenInfo } from "@types";
import "./UnstakeAmount.scss";
import { useChainId } from "wagmi";



export declare type UnstakeAmountProps = {

};


export const UnstakeAmount: FunctionComponent<UnstakeAmountProps> = ({

}) => {

	const classes = () => [ `unstake-modal`, `unstake-amount`,  ].join(" ");

	const chainId = useChainId()
	const {
		busy,
		balances,
		withdrawInToken,
		withdrawAmount,
		setWithdrawAmount,
		toUSD,
		applyMaxWithdraw,
	} = useEscrowStore();

	if(!withdrawInToken) throw new Error("UnstakeAmount view cannot perform without a valid withdraw token set"); 

	const onTokenChange = ( token: TokenDefinition, ) => { };
	const onApplyMax = ( ) => applyMaxWithdraw();

	const onAmountChange = ( amount: NumericString, ) => {
		setWithdrawAmount(amount);
	}

	const balance = (
		withdrawInToken.label in balances
			? balances[withdrawInToken.label]
			: raise(`section "UnstakeAmount" was provided an unvailable token "${withdrawInToken}"`)
	) as bigint;

	const balanceUSD = toUSD(withdrawInToken,  bi( sn( withdrawAmount ) ));

	if( chainId ) {

		return (
			<div className={classes()}>
				<SelectableAssetDeposit
					chain={chainId!}
					token={getChainedToken(chainId, withdrawInToken.label)}
					amount={withdrawAmount}
					onTokenChange={onTokenChange}
					onValueChange={onAmountChange}
					balance={balance}
					balanceUSD={balanceUSD}
					showBalance
					fixedToken
					applyMax={onApplyMax}
					busy={busy}
				/>
			</div>
		);
	}
	throw new Error("@bracket/stake-app::UnstakeAmount is not on a valid chain");

}
